module.exports = __webpack_public_path__ + "img/11.faba2322.jpeg";